export const RECORD_BY_ID = id => `/attendance/student/${id}`
export const RECORD = '/attendance/student/'
export const LOGIN ="/login";
export const LOGOUT="";